export default __webpack_public_path__ + "static/topnotch-d8e3d521ebe8bf0bd7ca809eca3e5b76.webp";